import { lakeViewApi } from 'services/api/config';
import { TemplateApiPayload } from 'ui/modules/reports/pages/TemplatesPage/types';

export const createTemplateApi = async (
  payload: TemplateApiPayload[]
): Promise<TemplateApiPayload> => {
  const res = await lakeViewApi.post(`/v1/form`, payload);

  // Assuming the API returns the created template object (or an array with one)
  if (Array.isArray(res.data) && res.data.length > 0 && res.data[0]) {
    // If the payload was an array, the response might be an array of created templates.
    // We assume the first one is the one we're interested in if multiple were somehow created by one call.
    return res.data[0] as TemplateApiPayload;
  } else if (res.data && res.data.id) {
    // If the payload was a single object (though our type is TemplateApiPayload[]),
    // the response might be a single template object.
    return res.data as TemplateApiPayload;
  }
  console.error(
    'Failed to create template or API response format is unexpected:',
    res.data
  );
  throw new Error(
    'Failed to create template or API response format is unexpected.'
  );
};

export const getTemplatesApi = async (
  formType: string
): Promise<TemplateApiPayload[]> => {
  const params = {
    'page.size': 100,
    'page.number': 0,
    'order.by': 'id',
    'order.direction': 'ASC',
    formType: formType,
    defaultTemplate: 'true,false',
    systemTemplate: 'true,false',
  };

  const res = await lakeViewApi.get<{ content: TemplateApiPayload[] }>(
    `/v1/form`,
    { params }
  );
  return res.data.content;
};

export const updateTemplateApi = async (
  payload: TemplateApiPayload
): Promise<TemplateApiPayload> => {
  // The API expects an array for PUT, even if updating a single item by ID in the path
  // or if the ID is in the payload. We send an array with one item.
  const res = await lakeViewApi.put(`/v1/form`, [payload]);

  // Assuming the API returns the updated template object or an array with the updated template
  if (Array.isArray(res.data) && res.data.length > 0 && res.data[0]) {
    return res.data[0] as TemplateApiPayload;
  } else if (res.data && res.data.id) {
    return res.data as TemplateApiPayload;
  }
  console.error(
    'Failed to update template or API response format is unexpected:',
    res.data
  );
  throw new Error(
    'Failed to update template or API response format is unexpected.'
  );
};

export const deleteTemplateApi = async (templateId: string): Promise<void> => {
  try {
    await lakeViewApi.delete(`/v1/form/${templateId}`);
    // DELETE requests typically return 204 No Content on success,
    // so we don't expect a body.
  } catch (error) {
    console.error(`Failed to delete template with ID ${templateId}:`, error);
    // Rethrow or handle as appropriate for your application's error handling strategy
    throw error;
  }
};

export const getTemplateByIdApi = async (
  templateId: string
): Promise<TemplateApiPayload> => {
  try {
    const res = await lakeViewApi.get<TemplateApiPayload>(
      `/v1/form/${templateId}`
    );
    return res.data;
  } catch (error) {
    console.error(`Failed to fetch template with ID ${templateId}:`, error);
    throw error;
  }
};
